import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'app-on-off-badge',
  template: `
    <span [class]="state ? 'on' : 'off'" [ngClass]="size">
      {{ (state ? textOn : textOff) | transloco | uppercase }}
    </span>
  `,
  styleUrls: ['./on-off-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class OnOffBadgeComponent {
  @Input() state = false;
  @Input() textOn = 'general.feature.on';
  @Input() textOff = 'general.feature.off';
  @Input() size: 'sm' | 'lg' = 'sm';
}
